import { defineComponent as _defineComponent } from 'vue'
import AppPage from "@/components/layout/AppPage.vue"

export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationStepPage',
  setup(__props) {


return { __sfc: true,AppPage }
}

})